import { useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client, useScopedMerchantClient } from "./scoped-merchant-client";

export const useTikTokShopAuthUrl = (enabled = true) => {
  const scope = useScopedMerchantClient();
  return useQuery({
    queryKey: ["tts-shop", "auth-url", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      if (!scope.merchantId) return null;
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].tts["auth-url"].$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"].tts["auth-url"].$get({
            param: scope.param,
          });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    enabled: !!scope.merchantId && enabled,
    staleTime: 5 * 60 * 1000,
  });
};

export const useTikTokShopConnectionStatus = () => {
  const scope = useScopedMerchantClient();
  return useQuery({
    queryKey: ["tts-shop", "connection-status", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      if (!scope.merchantId) return null;
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].tts["connection-status"].$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"].tts["connection-status"].$get({
            param: scope.param,
          });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    enabled: !!scope.merchantId,
    staleTime: 30 * 1000,
  });
};

// Advanced marketplace filters (creator level, category pro, language) are a per-shop TikTok
// capability, not candidate/creator-specific data — shared by both the Candidate and Creator
// explorers (see UNB-1790).
export const useAdvancedFilters = () => {
  const scope = useScopedMerchantClient();
  return useQuery({
    queryKey: ["tts-shop", "advanced-filters", scope.merchantId, scope.workspaceId],
    queryFn: async () => {
      const res = scope.workspaceId
        ? await client.workspace[":workspaceId"].merchant[":merchantId"].tts["advanced-filters"].$get({
            param: scope.param,
          })
        : await client.merchant[":merchantId"].tts["advanced-filters"].$get({
            param: scope.param,
          });
      if (!res.ok) throw await handleError(res);
      return res.json();
    },
    enabled: !!scope.merchantId,
    staleTime: 5 * 60 * 1000,
  });
};
